import React, {useCallback, useEffect, useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {
    getFlatCode,
    maintenanceVaild,
} from "../../../components/commonmethod/CommonMethod";
import {
    ContentDetailInfoShell,
    ContentDetailThreeColLayout,
    DetailFilePanel,
    DetailFormTabChrome,
    DetailKvTable,
    DetailPanel,
    DetailSummaryButton,
} from "../../../components/detailLayout";
import Th_title from "../../../components/Th_title";
import ReadOnlyInputBasic from "../../../components/input/ReadOnlyInputBasic";
import UserSelectionField from "../../../components/selection/UserSelectionField";
import SearchSelector from "../../../components/searchSelector/SearchSelector";
import {SelectComboBoxForCreate} from "../../../components/select/SelectComboBoxForCreate";
import {getIncident, updateIncident} from "../../../api/maintenance/IncidentService";
import ApprovalComponent from "../../settings/approval/new/ApprovalComponent";
import {useDispatch, useSelector} from "react-redux";
import {inspectionRequestCode, useSla} from "../inspection/InspectionCreate";
import {
    changeProgressStatusValue,
    changeStatusNumericValue,
} from "../../../redux/slice/contentSlice";
import {
    clearApprovalProcessState,
    getApprovalProcessSubmitPayload,
    preloadApprovalProcessFromFlatCode,
} from "../../settings/approval/shared/approvalProcessStore";
import {incidentAcceptCode, incidentLevel, incidentType} from "./IncidentCreate";
import {CacheType, CodeSpecNum, ContentCategory} from "../../../constant/CodeSpecNum";
import {selectHandlers} from "../../../api/handler/handlerService";
import {getContentStatus} from "../../../api/contentStatus/contentStatusService";
import {apiLoading, skeleton} from "../../../redux/slice/apiSlice";
import {onCreateClickListener} from "../../../components/commonmethod/simmsDrawerMethod";
import SimmsInputSearch from "../../../components/input/SimmsInputSearch";
import SimmsDrawerSearch from "../../../components/drawer/simms/SimmsDrawerSearch";
import {inputOnChange} from "../../../components/commonmethod/simmsInputMethod";
import {SimmsRadio} from "../../../components/input/SimmsRadio";
import Selector from "../../../components/selector/Selector";
import SimmsDatePicker from "../../../components/datepicker/SimmsDatePicker";
import {dateOnChange} from "../../../components/commonmethod/simmsDateMethod";
import dayjs from "dayjs";
import SimmsInput from "../../../components/input/SimmsInput";
import SimmsTextArea from "../../../components/input/SimmsTextArea";
import {selectCodesByParentId} from "../../../api/code/CodeService";
import {useCacheRefresh} from "../../../hooks/useCacheRefresh";

function IncidentUpdate(){
    const {id} = useParams();
    const dispatch = useDispatch();
    const [incident, setIncident] = useState({});
    const [assets, setAssets] = useState([]);
    const [handler, setHandler] = useState([]);
    const [flatIncidentCode, setFlatIncidentCode] = useState([]);
    const refreshCache = useCacheRefresh();

    const location = useLocation();
    const navigate = useNavigate();
    const approvalProcessId = useSelector((state) => state.content.approvalProcess?.id);
    const approvalProcessIdAfter = useSelector((state) => state.content.approvalProcessAfter?.id);

    const preloadApprovalProcesses = useCallback((codeId, flatList) => {
        preloadApprovalProcessFromFlatCode(dispatch, codeId, flatList);
    }, [dispatch]);

    useEffect(() => {
        clearApprovalProcessState(dispatch);
        return () => clearApprovalProcessState(dispatch);
    }, [dispatch, id]);

    useEffect(() =>{
        Promise.all([
            getIncident(id),
            selectHandlers({ contentId: id, contentCategory: ContentCategory.INCIDENT }),
            getContentStatus({contentId : id, contentCategory : ContentCategory.INCIDENT})
        ]).then(([ incidentResponse, handlersResponse, statusNumericValueResponse]) => {
            setIncident(incidentResponse.data);
            setAssets(incidentResponse.data.maintenanceAssets?.map(each => each.assets));
            setHandler(handlersResponse.data);

            if (statusNumericValueResponse && statusNumericValueResponse.status === 200) {
                const numericValue = statusNumericValueResponse.data.statusNumericValue;
                dispatch(changeStatusNumericValue(numericValue));
                dispatch(changeProgressStatusValue(statusNumericValueResponse.data));
            }

            return selectCodesByParentId(CodeSpecNum.IncidentRequestCode)
                .then(incidentCodeResponse => {
                    setFlatIncidentCode(getFlatCode(incidentCodeResponse));
                })
        }).finally(
            dispatch(skeleton(false))
        )
    }, [id, dispatch])

    const requireds =["incidentType", "requester", "incidentCode", "incidentStartDate", "incidentEndDate", "title", "useSla", "inspector"]
    const update = async ()=>{
        if(incident.incidentType == "자산 장애" && assets.length == 0){
            alert("자산을 선택해주세요")
            return false;
        }

        if (!maintenanceVaild(handler, incident, requireds)) return;

        dispatch(apiLoading(true));

        const data = {
            ...incident,
            ...getApprovalProcessSubmitPayload({includeAfter: true}),
            incidentCode : {id : incident.incidentCode.id},
            inspector : {id : incident.inspector.id},
            requester : {id : incident.requester.id}
        }

        let assetData;
        if(incident.incidentType === "자산 장애"){
            assetData = assets;
        }

        await updateIncident(data, assetData, handler).then(response => {
            if(response.status === 200){
                alert("장애가 접수되었습니다.")
                refreshCache(CacheType.INCIDENT);
                navigate("/maintenance/incident/"+id, {
                    state: {
                        test: location.state
                    }
                });
            }
        }).finally(dispatch(apiLoading(false)));
    }

    useEffect(()=>{
        if(incident.incidentType === "복합 장애"){
            setAssets([]);
            setIncident((prev) => {
                const updateData = { ...prev };

                // `required_validate`가 존재할 때만 `assets` 값을 업데이트
                if (updateData.required_validate) {
                    updateData.required_validate.assets = true;
                }

                return updateData;
            });
        }
    }, [incident.incidentType])

    useEffect(() => {
        if (!incident.incidentCode?.id || flatIncidentCode.length === 0) {
            return;
        }

        preloadApprovalProcesses(incident.incidentCode.id, flatIncidentCode);
    }, [incident.incidentCode?.id, flatIncidentCode, preloadApprovalProcesses]);

    const goToDetail = () => navigate(`/maintenance/incident/${id}`);

    const requestInfoPanel = Object.keys(incident).length > 0 ? (
        <DetailPanel title="장애요청정보">
            <DetailKvTable>
                <tbody>
                    {incident.incidentType === "자산 장애" && (
                        <tr className="asset-detail-kv-row--auto">
                            <Th_title title="자산목록" colspan={3} className="fieldset-td relative align-top" required auth={incident.auth?.update}>
                                <UserSelectionField
                                    layout="inline"
                                    data={assets}
                                    countUnit="개"
                                    chipEntity="asset"
                                    listModalTitle="자산목록"
                                    onRemove={(v) => setAssets((prev) => prev.filter((asset) => asset.id !== v.id))}
                                >
                                    <SearchSelector
                                        auth={incident.auth?.update}
                                        multiSelect
                                        variant="compact"
                                        entity="maintenance-assets"
                                        uniqueKey="assets"
                                        data={assets}
                                        onChange={(v) => {
                                            if (v?.__multiFlat) setAssets(v.__multiFlat);
                                        }}
                                    >
                                        <SimmsInputSearch type="TEXT" />
                                        <SimmsDrawerSearch showLabel title="자산그룹" entity="code" target="group" parentKey={CodeSpecNum.AssetGroupCode} uniqueKey="group" recursive />
                                        <SimmsDrawerSearch showLabel title="업무그룹" entity="code" target="task" parentKey={CodeSpecNum.TaskGroupCode} uniqueKey="task" recursive />
                                        <SimmsDrawerSearch showLabel title="자산위치" entity="code" target="location" parentKey={CodeSpecNum.AssetLocation} uniqueKey="location" recursive />
                                        <SimmsDrawerSearch showLabel title="SLA 그룹" entity="code" target="slaGroup" parentKey={CodeSpecNum.SlaGroupCode} uniqueKey="slaGroup" recursive />
                                        <SimmsDrawerSearch showLabel title="운영담당자" entity="userAccount" target="operator" />
                                        <SimmsDrawerSearch showLabel title="자산사용자" entity="userAccount" target="handler" />
                                    </SearchSelector>
                                </UserSelectionField>
                            </Th_title>
                        </tr>
                    )}
                    <tr>
                        <Th_title title="등록일시" colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target="createdAt" value={incident.createdAt} />
                        </Th_title>
                        <Th_title title="등록자" colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target="createdBy" value={incident.createdBy} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title="수정일시" colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target="updatedAt" value={incident.updatedAt} />
                        </Th_title>
                        <Th_title title="수정자" colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target="updatedBy" value={incident.updatedBy} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title="장애 제목" colspan={3} className="fieldset-td" required auth={incident.auth?.update}>
                            <SimmsInput onChange={(v) => inputOnChange(setIncident, "title", v, true)} data={incident.title} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title="요청자" colspan={3} className="fieldset-td" required auth={incident.auth?.update}>
                            <Selector
                                onChange={(v) => onCreateClickListener(setIncident, "requester", incident.requester, v)}
                                data={incident.requester}
                                entity="userAccount"
                                uniqueKey="requester"
                            >
                                <SimmsInputSearch type="TEXT" placeHolder="사용자명" />
                                <SimmsDrawerSearch showLabel title="부서" entity="department" target="department" recursive />
                                <SimmsDrawerSearch showLabel title="업체" entity="company" target="company" />
                            </Selector>
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title="장애유형" colspan={1} className="fieldset-td" required auth={incident.auth?.update}>
                            <Selector
                                onChange={(v) => onCreateClickListener(setIncident, "incidentCode", incident.incidentCode, v)}
                                data={incident.incidentCode}
                                entity="code"
                                parentKey={CodeSpecNum.IncidentRequestCode}
                                recursive
                            />
                        </Th_title>
                        <Th_title title="요청방식" colspan={1} className="fieldset-td" auth={incident.auth?.update}>
                            <SelectComboBoxForCreate
                                target="incidentRequest"
                                options={inspectionRequestCode}
                                data={{data: incident, fnc: setIncident}}
                                defaultValue={incident.incidentRequest}
                            />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title="장애인지" colspan={1} className="fieldset-td" auth={incident.auth?.update}>
                            <div className="flex items-center gap-1 w-full min-w-0">
                                <SelectComboBoxForCreate
                                    target="incidentAcceptCode"
                                    options={incidentAcceptCode}
                                    data={{data: incident, fnc: setIncident}}
                                    defaultValue={incident.incidentAcceptCode}
                                />
                                <SimmsInput
                                    onChange={(v) => inputOnChange(setIncident, "incidentAcceptText", v, false)}
                                    data={incident.incidentAcceptText}
                                    style={{flex: "1 1 auto", minWidth: 0, width: "auto"}}
                                />
                            </div>
                        </Th_title>
                        <Th_title title="장애등급" colspan={1} className="fieldset-td" auth={incident.auth?.update}>
                            <SelectComboBoxForCreate
                                target="incidentLevel"
                                options={incidentLevel}
                                data={{data: incident, fnc: setIncident}}
                                defaultValue={incident.incidentLevel}
                            />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title="장애구분" colspan={3} className="fieldset-td" required auth={incident.auth?.update}>
                            <SimmsRadio
                                options={incidentType}
                                onChange={(v) => inputOnChange(setIncident, "incidentType", v, true)}
                                data={incident.incidentType}
                            />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title="장애기간" colspan={3} className="fieldset-td fieldset-td-input" required>
                            <div className="web-flex asset-detail-date-range">
                                <SimmsDatePicker
                                    onChange={(v) => dateOnChange(setIncident, "incidentStartDate", v, true)}
                                    data={incident.incidentStartDate}
                                    time
                                    constraint={{lessThan: incident.incidentEndDate && dayjs(incident.incidentEndDate), required: true}}
                                    auth={incident.auth?.update}
                                />
                                <span className="asset-detail-date-range-sep">~</span>
                                <SimmsDatePicker
                                    onChange={(v) => dateOnChange(setIncident, "incidentEndDate", v, true)}
                                    data={incident.incidentEndDate}
                                    time
                                    constraint={{largerThan: incident.incidentStartDate && dayjs(incident.incidentStartDate), required: true}}
                                    auth={incident.auth?.update}
                                />
                            </div>
                        </Th_title>
                    </tr>
                    <tr className="asset-detail-kv-row--auto">
                        <Th_title title="장애내용" colspan={3} className="fieldset-td" auth={incident.auth?.update}>
                            <SimmsTextArea onChange={(v) => inputOnChange(setIncident, "incidentContent", v, false)} data={incident.incidentContent} style={{width: "100%", minHeight: "80px"}} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title="SLA 사용여부" colspan={3} className="fieldset-td" required auth={incident.auth?.update}>
                            <SimmsRadio
                                options={useSla}
                                onChange={(v) => inputOnChange(setIncident, "useSla", v, true)}
                                data={incident.useSla}
                            />
                        </Th_title>
                    </tr>
                    <tr className="asset-detail-kv-row--auto">
                        <Th_title title="비고" colspan={3} className="fieldset-td" auth={incident.auth?.update}>
                            <SimmsTextArea onChange={(v) => inputOnChange(setIncident, "etc", v, false)} data={incident.etc} style={{width: "100%", minHeight: "80px"}} />
                        </Th_title>
                    </tr>
                </tbody>
            </DetailKvTable>
        </DetailPanel>
    ) : null;

    const workflowPanels = Object.keys(incident).length > 0 ? (
        <>
            <DetailPanel title="장애 요청 진행상태">
                <DetailKvTable>
                    <tbody>
                        <tr className="asset-detail-kv-row--auto">
                            <Th_title title="담당자" colspan={3} className="fieldset-td fieldset-td-input relative align-top" required auth={incident.auth?.update}>
                                <UserSelectionField
                                    layout="inline"
                                    data={handler}
                                    onRemove={(v) => setHandler((prev) => prev.filter((h) => h.id !== v.id))}
                                >
                                    <SearchSelector
                                        auth={incident.auth?.update}
                                        multiSelect
                                        variant="compact"
                                        entity="userAccount"
                                        uniqueKey="handler"
                                        data={handler}
                                        onChange={(v) => {
                                            if (v?.__multiFlat) setHandler(v.__multiFlat);
                                        }}
                                    >
                                        <SimmsInputSearch type="TEXT" placeHolder="사용자명" />
                                        <SimmsDrawerSearch showLabel title="부서" entity="department" target="department" recursive />
                                        <SimmsDrawerSearch showLabel title="업체" entity="company" target="company" />
                                    </SearchSelector>
                                </UserSelectionField>
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title="검수자" colspan={3} className="fieldset-td" required auth={incident.auth?.update}>
                                <Selector
                                    onChange={(v) => onCreateClickListener(setIncident, "inspector", incident.inspector, v)}
                                    data={incident.inspector}
                                    entity="userAccount"
                                    uniqueKey="inspector"
                                >
                                    <SimmsInputSearch type="TEXT" placeHolder="사용자명" />
                                    <SimmsDrawerSearch showLabel title="부서" entity="department" target="department" recursive />
                                    <SimmsDrawerSearch showLabel title="업체" entity="company" target="company" />
                                </Selector>
                            </Th_title>
                        </tr>
                    </tbody>
                </DetailKvTable>
            </DetailPanel>
        </>
    ) : null;

    const asidePanel = Object.keys(incident).length > 0 ? (
        <>
            <ApprovalComponent auth={incident.auth?.update} approvalProcessId={approvalProcessId} />
            <ApprovalComponent auth={incident.auth?.update} title="사후결재" approvalSeparator approvalProcessId={approvalProcessIdAfter} />
            <DetailFilePanel
                title="첨부"
                isEditing={Boolean(incident.auth?.update)}
                tableInfo={{tableName: "Incident", joinKey: incident.id}}
            />
        </>
    ) : null;

    if (Object.keys(incident).length > 0 && Object.keys(flatIncidentCode).length > 0) {
        const summaryMeta = [
            incident.incidentType,
            incident.incidentCode?.name,
            incident.number && `번호 ${incident.number}`,
        ].filter(Boolean).join(" · ");

        return (
            <div className="common-container container-height detail-list-layout asset-detail-list-layout border-l-gray flex min-h-0 flex-1 flex-col">
                <DetailFormTabChrome>
                    <ContentDetailInfoShell
                        title={incident.title || "장애 접수"}
                        meta={summaryMeta || undefined}
                        contentId={id}
                        contentCategory={ContentCategory.INCIDENT}
                        scrollMode="columns"
                        actions={
                            <DetailSummaryButton muted onClick={goToDetail}>
                                취소
                            </DetailSummaryButton>
                        }
                        rollup={{
                            update: incident.auth?.update ? update : "",
                            updateTitle: "접수완료",
                        }}
                    >
                        <ContentDetailThreeColLayout
                            primary={requestInfoPanel}
                            secondary={workflowPanels}
                            aside={asidePanel}
                        />
                    </ContentDetailInfoShell>
                </DetailFormTabChrome>
            </div>
        );
    }
}

export {IncidentUpdate}